import StackedChart from "./StackedChart";
export default StackedChart;